import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=4d954255&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=4d954255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d954255",
  null
  
)

export default component.exports